const member = {
  namespaced: true,
  state: {
    accessToken: '',
    refreshToken: '',
    tokenExpireTime: '',
    defaultAddress: {},
    userInfo: {},
  },
  mutations: {
    SET_TOKEN(state, payload) {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.tokenExpireTime = payload.tokenExpireTime;
    },
    SET_DEFAULT_ADDRESS(state, payload) {
      state.defaultAddress = payload.data.data;
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload.data.data;
    },
    LOGOUT() {
      this.state = {
        accessToken: '',
        refreshToken: '',
        defaultAddress: {},
        userInfo: {},
      };
    },
  },
  getters: {
    // COA 관리/상세 쓰기 권한 — 계정구분의 메뉴코드에 COMGMTW 포함 여부 (없으면 조회·다운로드만)
    canWriteCoa: state =>
      ((state.userInfo && state.userInfo.menu_codes) || '')
        .split(',')
        .map(v => v.trim())
        .includes('COMGMTW'),
  },
  actions: {},
};

export default member;
